import * as React from 'react'

export const GuestModal = ({
  guestURL,
  signInURL,
}: {
  guestURL: string,
  signInURL: string,
}) => {
  const [continueAsGuest, setContinueAsGuest] = React.useState<boolean>(true)
  const handleContinue = React.useCallback(() => {
    window.location.href = continueAsGuest ? guestURL : signInURL
  }, [guestURL, signInURL, continueAsGuest])

  return (
    <>
      <h2 className="title">Continue As Guest?</h2>
      <div className="form-check mt-4">
        <input
          id="guest-modal-yes"
          type="radio"
          className="form-check-input"
          checked={continueAsGuest}
          onChange={() => setContinueAsGuest(true)}
        />
        <label htmlFor="guest-modal-yes" className="form-check-label">
          Check out as a guest
        </label>
      </div>
      <div className="form-check mt-2">
        <input
          id="guest-modal-no"
          type="radio"
          className="form-check-input"
          checked={!continueAsGuest}
          onChange={() => setContinueAsGuest(false)}
        />
        <label htmlFor="guest-modal-no" className="form-check-label">
          Use my Watermark Resources account
        </label>
      </div>
      <a className="mt-3 button large primary" onClick={handleContinue}>
        Continue
      </a>
    </>
  )
}
